import { templateLocationTypes } from '@qdabra/forms-shared';
import { throwTemplateNotFoundError } from '../utility/errorCreators';

const { LOCATION_TYPE_TEMPLATE_NAME } = templateLocationTypes;

const templateInfoSource = function (api, preloadData) {
    const getTemplateInfoAsync = async () => {
        const templateInfo = preloadData.templateInfo;

        if (templateInfo) {
            return templateInfo;
        }

        const accessType = api.getAccessType();

        const isTemplateAccessType =
            accessType === LOCATION_TYPE_TEMPLATE_NAME ||
            accessType === 'template';

        if (!isTemplateAccessType) {
            return null;
        }

        // getTemplateInfoAsync will return info if
        // templateName is specified and it exists in FormsViewer
        // template is specified and it is mapped to a FormsViewer template in Manage Hrefs
        const queriedTemplateInfo = await api.getTemplateInfoAsync({
            countUsage: true,
        });

        if (
            accessType === LOCATION_TYPE_TEMPLATE_NAME &&
            !queriedTemplateInfo
        ) {
            throwTemplateNotFoundError(api.getTemplateLocation());
        }

        return queriedTemplateInfo;
    };

    return {
        getTemplateInfoAsync,
    };
};

export default templateInfoSource;
